// Renders server-sanitized rich-text HTML. Content is sanitized on the backend (nh3) before storage.
export function RichHtml({ html, className = "", testid }) {
  if (!html || !String(html).trim()) return null;
  return <div data-testid={testid} className={`ms-rich ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
